/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderCreateDto } from '../../models/shop-order-create-dto';
import { ShopOrderDto } from '../../models/shop-order-dto';

export interface ShopOrderClientControllerCreateV1$Params {
      body: ShopOrderCreateDto
}

export function shopOrderClientControllerCreateV1(http: HttpClient, rootUrl: string, params: ShopOrderClientControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderClientControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDto>;
    })
  );
}

shopOrderClientControllerCreateV1.PATH = '/api/v1/shop-orders/client';
